<template>
  <div>
    <el-pagination :class="[align]" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.pageIndex" :page-sizes="pageSizes" :page-size="pagination.pageSize" :layout="layout"
      :total="pagination.dataCount">
      <span class="el-pagination__total">共 {{ pagination.dataCount }} 条记录</span>
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: function () {
        return Object
      }
    },
    layout: {
      type: String,
      default: "slot,sizes,prev,pager,next,jumper",
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 15, 20, 50, 100];
      }
    },
    align: {
      type: String,
      default: "left",
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 15,
    }
  },
  watch: {
    pagination: function (newValue) {
      this.pageSize = newValue.pageSize;
    }
  },
  mounted() {
    this.pageSize = this.pagination.pageSize;
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (Math.ceil(this.pagination.dataCount / val) < this.pageIndex) return;
      this.$emit("handleSizeChange", { pageIndex: this.pageIndex, pageSize: this.pageSize });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.$emit("handleCurrentChange", { pageIndex: this.pageIndex, pageSize: this.pageSize });
    },
  }
}
</script>

<style lang="scss">
.el-pagination {
  margin-top: 15px;
  position: relative;
  &.right {
    text-align: right;
    .el-pagination__total {
      position: absolute;
      left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ListPagination.vue